import type { ReactNode } from "react";
import { BrandPattern } from "@/components/BrandPattern";

// The Exchange landings' hero: /portal, /direct-markets and the surety
// exchanges (BRK-S276; docs/design-system.md § Brand). It is built from the
// brand book:
// - the eyebrow is set as the book sets its labels, Kräftig capitals tracked
//   out;
// - the headline is the book's hero headline, Halbfett at normal spacing (the
//   display style);
// - the art is the book's outlined-chevron pattern, cropped by the card's
//   edges.
//
// There is no mark in it: the logo is already in the sidebar, and the book's
// rules for the mark (clear space, no effects) are why the old illustration
// went. It is compact (Nav, BRK-S264), so at 1440×900 whatever follows it
// starts above the fold. It holds the page's one h1; a hero is allowed its
// own (test/lib/page-header-conformance.test.ts).
export function ExchangeHero({
  eyebrow,
  title,
  subtitle,
  actions,
}: {
  eyebrow: string;
  title: ReactNode;
  subtitle: ReactNode;
  /** The calls to action, if the landing has any. */
  actions?: ReactNode;
}) {
  return (
    <section
      data-exchange-hero
      className="relative overflow-hidden rounded-xl border border-brk-border bg-brk-panel"
    >
      <BrandPattern className="pointer-events-none absolute inset-y-0 right-0 hidden h-full w-1/2 max-w-xl text-brk-accent/50 lg:block" />
      <div className="relative flex max-w-2xl flex-col gap-2 p-5 sm:p-6">
        <p className="text-meta font-medium uppercase tracking-widest text-brk-accent">
          {eyebrow}
        </p>
        <h1 className="text-display text-brk-text">{title}</h1>
        <p className="max-w-prose text-brk-dim">{subtitle}</p>
        {actions && (
          <div
            data-hero-actions
            className="flex flex-col items-stretch gap-3 pt-2 sm:flex-row sm:items-start"
          >
            {actions}
          </div>
        )}
      </div>
    </section>
  );
}
